<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view-own',
    subject: 'Task',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-task-line',
  color: 'primary',
  title: 'Task & Tindak Lanjut',
  description: 'Melihat, mengerjakan, dan menyelesaikan task yang ditugaskan ke Anda.',
  purpose: 'Panduan halaman "Task Saya" — daftar seluruh tugas Anda dari berbagai sumber (CAPA, checklist MFK, rapat, dst.).',
  concept: [
    {
      icon: 'ri-share-forward-line',
      title: 'Task Bisa Datang dari Mana Saja',
      text: 'Task tidak selalu Anda buat sendiri — bisa muncul otomatis dari checklist MFK yang menemukan masalah, dari CAPA, atau dari tindak lanjut rapat.',
    },
  ],
  steps: [
    { title: 'Buka menu Task Saya', detail: 'Menampilkan seluruh task dengan Anda sebagai penanggung jawab (PIC).' },
    { title: 'Klik satu task untuk melihat detailnya', detail: 'Termasuk asal task tersebut (CAPA/checklist/rapat mana).' },
    { title: 'Kerjakan tugasnya di dunia nyata', detail: 'Task hanya mencatat status — pekerjaan sebenarnya di luar sistem.' },
    { title: 'Klik "Selesaikan" setelah tugas benar-benar selesai', detail: 'Status task berubah menjadi Selesai dan tercatat waktunya.' },
  ],
  tips: [
    'Kalau task salah ditugaskan ke Anda, minta admin/atasan Anda untuk mengalihkannya (reassign) ke orang yang tepat.',
  ],
  faq: [
    { q: 'Bisakah saya menghapus task yang sudah selesai?', a: 'Tidak — task yang sudah selesai tidak bisa dihapus sama sekali, untuk menjaga jejak audit tindak lanjut tetap lengkap.' },
  ],
  related: [
    { title: 'CAPA', sub: 'Salah satu sumber Task yang paling umum', icon: 'ri-tools-line', color: 'primary', to: { name: 'help-mutu-capa' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
